/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { CalcService } from './services/CalcService';
import { ChecklistDefinitionService } from './services/ChecklistDefinitionService';
import { ChecklistInstancesService } from './services/ChecklistInstancesService';
import { ContactActivityService } from './services/ContactActivityService';
import { ContactActivityBackfillService } from './services/ContactActivityBackfillService';
import { CoupleStudioRoomPreferenceCleanupService } from './services/CoupleStudioRoomPreferenceCleanupService';
import { CrossDbSyncService } from './services/CrossDbSyncService';
import { DashboardService } from './services/DashboardService';
import { DataAnonymizationService } from './services/DataAnonymizationService';
import { DataExtractService } from './services/DataExtractService';
import { DateSubmittedBackfillService } from './services/DateSubmittedBackfillService';
import { EmailTemplatesService } from './services/EmailTemplatesService';
import { EntityService } from './services/EntityService';
import { EntityBackfillService } from './services/EntityBackfillService';
import { EntityDefinitionService } from './services/EntityDefinitionService';
import { FileUploadService } from './services/FileUploadService';
import { FinderInputService } from './services/FinderInputService';
import { FormDefinitionService } from './services/FormDefinitionService';
import { FormDesignerExtrasService } from './services/FormDesignerExtrasService';
import { FormElementService } from './services/FormElementService';
import { FormResponseService } from './services/FormResponseService';
import { FormResponseAnswerService } from './services/FormResponseAnswerService';
import { FormResponseFileUploadService } from './services/FormResponseFileUploadService';
import { FormResponsesService } from './services/FormResponsesService';
import { FormResponseStatusService } from './services/FormResponseStatusService';
import { FormSectionRuleService } from './services/FormSectionRuleService';
import { GeneralService } from './services/GeneralService';
import { HousingApplicationService } from './services/HousingApplicationService';
import { HousingApplicationExcelReportService } from './services/HousingApplicationExcelReportService';
import { HousingApplicationLogService } from './services/HousingApplicationLogService';
import { HousingApplicationMigrationService } from './services/HousingApplicationMigrationService';
import { HousingBulkUploadService } from './services/HousingBulkUploadService';
import { HousingDataFixService } from './services/HousingDataFixService';
import { HousingFinderInputRoomPreferenceV2BackfillService } from './services/HousingFinderInputRoomPreferenceV2BackfillService';
import { HousingIntakeScenarioService } from './services/HousingIntakeScenarioService';
import { HousingModuleRolesService } from './services/HousingModuleRolesService';
import { HousingOrgService } from './services/HousingOrgService';
import { HousingOrgRolesService } from './services/HousingOrgRolesService';
import { HousingSiteDetailsService } from './services/HousingSiteDetailsService';
import { HousingSitesService } from './services/HousingSitesService';
import { ItemDefinitionService } from './services/ItemDefinitionService';
import { ItemInstanceService } from './services/ItemInstanceService';
import { ListDefinitionService } from './services/ListDefinitionService';
import { LocationMigrationService } from './services/LocationMigrationService';
import { LogClientActivityService } from './services/LogClientActivityService';
import { LogEventService } from './services/LogEventService';
import { LoginAccountService } from './services/LoginAccountService';
import { LoginAccountManagementService } from './services/LoginAccountManagementService';
import { MailService } from './services/MailService';
import { MainDashboardService } from './services/MainDashboardService';
import { NameStampAnswerService } from './services/NameStampAnswerService';
import { NotificationBackfillService } from './services/NotificationBackfillService';
import { OldHousingDataImportService } from './services/OldHousingDataImportService';
import { OrgGroupService } from './services/OrgGroupService';
import { PdfService } from './services/PdfService';
import { PersonService } from './services/PersonService';
import { PersonMigrationService } from './services/PersonMigrationService';
import { ReminderService } from './services/ReminderService';
import { RoomPreferenceV2FromSelectionsBackfillService } from './services/RoomPreferenceV2FromSelectionsBackfillService';
import { SaveToTableAdminService } from './services/SaveToTableAdminService';
import { ScenarioMigrationService } from './services/ScenarioMigrationService';
import { SchedulerAdminService } from './services/SchedulerAdminService';
import { SectorNodeGuidsBackfillService } from './services/SectorNodeGuidsBackfillService';
import { ShortcodeService } from './services/ShortcodeService';
import { SiteCodeRemapService } from './services/SiteCodeRemapService';
import { SiteResultConfigBackfillService } from './services/SiteResultConfigBackfillService';
import { SiteSelectionMigrationService } from './services/SiteSelectionMigrationService';
import { SiteUnitConfigBackfillService } from './services/SiteUnitConfigBackfillService';
import { StuckLockedApplicationsService } from './services/StuckLockedApplicationsService';
import { SysOrgService } from './services/SysOrgService';
import { SystemService } from './services/SystemService';
import { TicketsService } from './services/TicketsService';
import { TreeService } from './services/TreeService';
import { UserInfoService } from './services/UserInfoService';
import { WorkflowDefinitionService } from './services/WorkflowDefinitionService';
import { WorkflowInstanceService } from './services/WorkflowInstanceService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
    public readonly calc: CalcService;
    public readonly checklistDefinition: ChecklistDefinitionService;
    public readonly checklistInstances: ChecklistInstancesService;
    public readonly contactActivity: ContactActivityService;
    public readonly contactActivityBackfill: ContactActivityBackfillService;
    public readonly coupleStudioRoomPreferenceCleanup: CoupleStudioRoomPreferenceCleanupService;
    public readonly crossDbSync: CrossDbSyncService;
    public readonly dashboard: DashboardService;
    public readonly dataAnonymization: DataAnonymizationService;
    public readonly dataExtract: DataExtractService;
    public readonly dateSubmittedBackfill: DateSubmittedBackfillService;
    public readonly emailTemplates: EmailTemplatesService;
    public readonly entity: EntityService;
    public readonly entityBackfill: EntityBackfillService;
    public readonly entityDefinition: EntityDefinitionService;
    public readonly fileUpload: FileUploadService;
    public readonly finderInput: FinderInputService;
    public readonly formDefinition: FormDefinitionService;
    public readonly formDesignerExtras: FormDesignerExtrasService;
    public readonly formElement: FormElementService;
    public readonly formResponse: FormResponseService;
    public readonly formResponseAnswer: FormResponseAnswerService;
    public readonly formResponseFileUpload: FormResponseFileUploadService;
    public readonly formResponses: FormResponsesService;
    public readonly formResponseStatus: FormResponseStatusService;
    public readonly formSectionRule: FormSectionRuleService;
    public readonly general: GeneralService;
    public readonly housingApplication: HousingApplicationService;
    public readonly housingApplicationExcelReport: HousingApplicationExcelReportService;
    public readonly housingApplicationLog: HousingApplicationLogService;
    public readonly housingApplicationMigration: HousingApplicationMigrationService;
    public readonly housingBulkUpload: HousingBulkUploadService;
    public readonly housingDataFix: HousingDataFixService;
    public readonly housingFinderInputRoomPreferenceV2Backfill: HousingFinderInputRoomPreferenceV2BackfillService;
    public readonly housingIntakeScenario: HousingIntakeScenarioService;
    public readonly housingModuleRoles: HousingModuleRolesService;
    public readonly housingOrg: HousingOrgService;
    public readonly housingOrgRoles: HousingOrgRolesService;
    public readonly housingSiteDetails: HousingSiteDetailsService;
    public readonly housingSites: HousingSitesService;
    public readonly itemDefinition: ItemDefinitionService;
    public readonly itemInstance: ItemInstanceService;
    public readonly listDefinition: ListDefinitionService;
    public readonly locationMigration: LocationMigrationService;
    public readonly logClientActivity: LogClientActivityService;
    public readonly logEvent: LogEventService;
    public readonly loginAccount: LoginAccountService;
    public readonly loginAccountManagement: LoginAccountManagementService;
    public readonly mail: MailService;
    public readonly mainDashboard: MainDashboardService;
    public readonly nameStampAnswer: NameStampAnswerService;
    public readonly notificationBackfill: NotificationBackfillService;
    public readonly oldHousingDataImport: OldHousingDataImportService;
    public readonly orgGroup: OrgGroupService;
    public readonly pdf: PdfService;
    public readonly person: PersonService;
    public readonly personMigration: PersonMigrationService;
    public readonly reminder: ReminderService;
    public readonly roomPreferenceV2FromSelectionsBackfill: RoomPreferenceV2FromSelectionsBackfillService;
    public readonly saveToTableAdmin: SaveToTableAdminService;
    public readonly scenarioMigration: ScenarioMigrationService;
    public readonly schedulerAdmin: SchedulerAdminService;
    public readonly sectorNodeGuidsBackfill: SectorNodeGuidsBackfillService;
    public readonly shortcode: ShortcodeService;
    public readonly siteCodeRemap: SiteCodeRemapService;
    public readonly siteResultConfigBackfill: SiteResultConfigBackfillService;
    public readonly siteSelectionMigration: SiteSelectionMigrationService;
    public readonly siteUnitConfigBackfill: SiteUnitConfigBackfillService;
    public readonly stuckLockedApplications: StuckLockedApplicationsService;
    public readonly sysOrg: SysOrgService;
    public readonly system: SystemService;
    public readonly tickets: TicketsService;
    public readonly tree: TreeService;
    public readonly userInfo: UserInfoService;
    public readonly workflowDefinition: WorkflowDefinitionService;
    public readonly workflowInstance: WorkflowInstanceService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.calc = new CalcService(this.request);
        this.checklistDefinition = new ChecklistDefinitionService(this.request);
        this.checklistInstances = new ChecklistInstancesService(this.request);
        this.contactActivity = new ContactActivityService(this.request);
        this.contactActivityBackfill = new ContactActivityBackfillService(this.request);
        this.coupleStudioRoomPreferenceCleanup = new CoupleStudioRoomPreferenceCleanupService(this.request);
        this.crossDbSync = new CrossDbSyncService(this.request);
        this.dashboard = new DashboardService(this.request);
        this.dataAnonymization = new DataAnonymizationService(this.request);
        this.dataExtract = new DataExtractService(this.request);
        this.dateSubmittedBackfill = new DateSubmittedBackfillService(this.request);
        this.emailTemplates = new EmailTemplatesService(this.request);
        this.entity = new EntityService(this.request);
        this.entityBackfill = new EntityBackfillService(this.request);
        this.entityDefinition = new EntityDefinitionService(this.request);
        this.fileUpload = new FileUploadService(this.request);
        this.finderInput = new FinderInputService(this.request);
        this.formDefinition = new FormDefinitionService(this.request);
        this.formDesignerExtras = new FormDesignerExtrasService(this.request);
        this.formElement = new FormElementService(this.request);
        this.formResponse = new FormResponseService(this.request);
        this.formResponseAnswer = new FormResponseAnswerService(this.request);
        this.formResponseFileUpload = new FormResponseFileUploadService(this.request);
        this.formResponses = new FormResponsesService(this.request);
        this.formResponseStatus = new FormResponseStatusService(this.request);
        this.formSectionRule = new FormSectionRuleService(this.request);
        this.general = new GeneralService(this.request);
        this.housingApplication = new HousingApplicationService(this.request);
        this.housingApplicationExcelReport = new HousingApplicationExcelReportService(this.request);
        this.housingApplicationLog = new HousingApplicationLogService(this.request);
        this.housingApplicationMigration = new HousingApplicationMigrationService(this.request);
        this.housingBulkUpload = new HousingBulkUploadService(this.request);
        this.housingDataFix = new HousingDataFixService(this.request);
        this.housingFinderInputRoomPreferenceV2Backfill = new HousingFinderInputRoomPreferenceV2BackfillService(this.request);
        this.housingIntakeScenario = new HousingIntakeScenarioService(this.request);
        this.housingModuleRoles = new HousingModuleRolesService(this.request);
        this.housingOrg = new HousingOrgService(this.request);
        this.housingOrgRoles = new HousingOrgRolesService(this.request);
        this.housingSiteDetails = new HousingSiteDetailsService(this.request);
        this.housingSites = new HousingSitesService(this.request);
        this.itemDefinition = new ItemDefinitionService(this.request);
        this.itemInstance = new ItemInstanceService(this.request);
        this.listDefinition = new ListDefinitionService(this.request);
        this.locationMigration = new LocationMigrationService(this.request);
        this.logClientActivity = new LogClientActivityService(this.request);
        this.logEvent = new LogEventService(this.request);
        this.loginAccount = new LoginAccountService(this.request);
        this.loginAccountManagement = new LoginAccountManagementService(this.request);
        this.mail = new MailService(this.request);
        this.mainDashboard = new MainDashboardService(this.request);
        this.nameStampAnswer = new NameStampAnswerService(this.request);
        this.notificationBackfill = new NotificationBackfillService(this.request);
        this.oldHousingDataImport = new OldHousingDataImportService(this.request);
        this.orgGroup = new OrgGroupService(this.request);
        this.pdf = new PdfService(this.request);
        this.person = new PersonService(this.request);
        this.personMigration = new PersonMigrationService(this.request);
        this.reminder = new ReminderService(this.request);
        this.roomPreferenceV2FromSelectionsBackfill = new RoomPreferenceV2FromSelectionsBackfillService(this.request);
        this.saveToTableAdmin = new SaveToTableAdminService(this.request);
        this.scenarioMigration = new ScenarioMigrationService(this.request);
        this.schedulerAdmin = new SchedulerAdminService(this.request);
        this.sectorNodeGuidsBackfill = new SectorNodeGuidsBackfillService(this.request);
        this.shortcode = new ShortcodeService(this.request);
        this.siteCodeRemap = new SiteCodeRemapService(this.request);
        this.siteResultConfigBackfill = new SiteResultConfigBackfillService(this.request);
        this.siteSelectionMigration = new SiteSelectionMigrationService(this.request);
        this.siteUnitConfigBackfill = new SiteUnitConfigBackfillService(this.request);
        this.stuckLockedApplications = new StuckLockedApplicationsService(this.request);
        this.sysOrg = new SysOrgService(this.request);
        this.system = new SystemService(this.request);
        this.tickets = new TicketsService(this.request);
        this.tree = new TreeService(this.request);
        this.userInfo = new UserInfoService(this.request);
        this.workflowDefinition = new WorkflowDefinitionService(this.request);
        this.workflowInstance = new WorkflowInstanceService(this.request);
    }
}

